import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import EducationItem from "./EducationItem";
import { AuthContext } from "../context/AuthContext";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import sortDatesDesc from "../genericFunctions/sortDatesDesc";
import Grid from "@material-ui/core/Grid";

const Educations = (props) => {
  const onSubmitEducations = props.onSubmitEducations;
  const handleRemoveEducation = props.handleRemoveEducation;
  const updateEducation = props.updateEducation;
  const educations = props.educations;
  const [education, setEducation] = useState({
    name: "",
    school: "",
    fromDate: null,
    toDate: null,
    ongoing: false,
  });
  const [addingNew, setAddingNew] = useState(false);

  const authContext = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (education.ongoing) {
      setEducation({ ...education, toDate: null });
    } else if (!education.ongoing) {
      setEducation({ ...education });
    }
  }, [education.ongoing]); // eslint-disable-line react-hooks/exhaustive-deps
  const validateExperience = () => {
    if (
      education.name === "" ||
      education.school === "" ||
      education.fromDate === null ||
      ((education.toDate === null ||
        isNaN(Date.parse(education.toDate)) ||
        education.fromDate.getTime() > education.toDate.getTime()) &&
        education.ongoing === false) ||
      isNaN(Date.parse(education.fromDate))
    ) {
      return false;
    }
    return true;
  };
  const onChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setEducation({ ...education, [name]: value });
  };

  return (
    <Paper
      elevation={3}
      style={{
        margin: "10px 0px 10px 0px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: "97%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "education")}</h4>
          <IconButton
            onClick={() => setAddingNew(true)}
            variant="outlined"
            color="primary"
          >
            <AddIcon />
          </IconButton>
        </div>
        {addingNew && (
          <Paper
            elevation={1}
            style={{
              margin: "10px 0px",
              padding: "10px",
              display: "flex",
              flexDirection: "column",
              minWidth: "100%",
            }}
          >
            <form
              onSubmit={(e) => {
                setAddingNew(false);
                onSubmitEducations(e, education);
                setEducation({
                  name: "",
                  school: "",
                  fromDate: null,
                  toDate: null,
                  ongoing: false,
                });
              }}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <TextField
                type="text"
                name="name"
                label="Name"
                value={education.name}
                onChange={onChange}
                style={{ margin: "5px 0px" }}
                variant="outlined"
              />
              <TextField
                type="text"
                name="school"
                label="School"
                value={education.school}
                onChange={onChange}
                variant="outlined"
                style={{ margin: "5px 0px" }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={education.ongoing}
                    onChange={onChange}
                    name="ongoing"
                    value={education.ongoing}
                    color="primary"
                  />
                }
                label="Ongoing"
                style={{ width: "30.5%", padding: "10px 2px 5px" }}
              />
              <div style={{ display: "flex" }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-between">
                    <KeyboardDatePicker
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      format="MM/yyyy"
                      views={["year", "month"]}
                      margin="normal"
                      id="date-picker-inline"
                      InputLabelProps={{ shrink: true }}
                      label="From date"
                      value={education.fromDate}
                      onChange={(date) => {
                        setEducation({ ...education, fromDate: date });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "40%" }}
                    />

                    {!education.ongoing && (
                      <KeyboardDatePicker
                        inputVariant="outlined"
                        disableToolbar
                        variant="inline"
                        format="MM/yyyy"
                        views={["year", "month"]}
                        margin="normal"
                        id="date-picker-inline"
                        InputLabelProps={{ shrink: true }}
                        label="To date"
                        value={education.toDate}
                        onChange={(date) => {
                          setEducation({ ...education, toDate: date });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        style={{ width: "40%" }}
                      />
                    )}
                  </Grid>
                </MuiPickersUtilsProvider>
              </div>

              <div style={{ display: "flex", marginTop: "10px" }}>
                <Button
                  disabled={!validateExperience()}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "10px" }}
                >
                  Add Education
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={() => setAddingNew(false)}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Paper>
        )}
        {educations === undefined || educations.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {getProfileLabel(props.profileLanguage, "noEducations")}
          </p>
        ) : (
          educations
            .sort((a, b) =>
              sortDatesDesc(new Date(a.fromDate), new Date(b.fromDate))
            )
            .map((education) => {
              return (
                <EducationItem
                  key={education._id}
                  education={education}
                  profileLanguage={props.profileLanguage}
                  removeEducation={(education) =>
                    handleRemoveEducation(education)
                  }
                  updateEducation={(e, education) =>
                    updateEducation(e, education)
                  }
                />
              );
            })
        )}
      </div>
    </Paper>
  );
};

export default Educations;
